import { render, staticRenderFns } from "./MonitorEdit.vue?vue&type=template&id=f4da1538&"
import script from "./MonitorEdit.vue?vue&type=script&lang=js&"
export * from "./MonitorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports